import { ADMIN, CONSUMER } from '../../../services/cognito/userGroups'

const ALLOW_ALL = [
  CONSUMER, ADMIN
]

const ALLOW_ALL_NON_ADMIN = [CONSUMER]

export const ALLOW = {
  mobile: {
    menu: {
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN
    }
  },
  tablet: {
    menu: {
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN
    }
  },
  desktop: {
    navmenu: {
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN
    }
  }
}
